import { useForm } from "@shared/features/form/useForm";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { LoginForm } from "./LoginForm";
import { baseLoginSchema } from "../../auth.schemas";
import useLoginMutation from "../../hooks/useLoginMutation";
import useGoogleLoginMutation from "../../hooks/useGoogleLoginMutation";
import useTrackLoginEvents from "../../hooks/useTrackLoginEvents";
import AuthContent from "../AuthContent/AuthContent";

type Props = {
  onSuccess?: (data: any) => void;
  hideSignupLink?: boolean;
  onError?: () => void;
};

export function LoginContainer({ onError, onSuccess, hideSignupLink }: Props) {
  const schema = baseLoginSchema;

  const fields = makeFormFields(["email", "password"]).map((field) => {
    if (field.name === "password") {
      return { ...field, autoComplete: "current-password" };
    }
    return field;
  });

  const loginMutation = useLoginMutation({
    onSuccess,
    schema,
    onError,
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: loginMutation.mutateAsync,
  });

  const googleLoginMutation = useGoogleLoginMutation({
    onSuccess,
    form,
    onError,
  });

  // Track login intent and login started events
  useTrackLoginEvents();

  return (
    <AuthContent title="Log in to your account" description="Welcome back.">
      <LoginForm
        fields={fields}
        form={form}
        onLogin={handleSubmit}
        onLoginWithGoogle={googleLoginMutation.mutateAsync}
        hideSignupLink={hideSignupLink}
      />
    </AuthContent>
  );
}

export default LoginContainer;
